import React from "react";

const Minus = () => (
  <svg className="icon-minus" width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.8125 0.6875V1.8125H13.1875V0.6875H0.8125Z" fill="#21211D"/>
</svg>
);

export default Minus;
